export default __webpack_public_path__ + "img/98eb0676fec69441fb3f0ee7bad06447.svg";